import React,{Component} from 'react';



class QuotationUserDisplay extends Component{
    
            
   
    
    render() {

        return (
            <tr>
                <td >
                    <p>{this.props.quote.quoteNumber}</p>
                </td>
                <td >
                    <p>{this.props.quote.customer.name}</p>
                </td>
                <td >
                    <p>{this.props.quote.customer.location}</p>
                </td>
                <td >
                    <p>{this.props.quote.customer.representative}</p>
                </td>
                <td >
                    <p>{this.props.quote.status}</p>
                </td>
                <td >
                    <button className="btn btn-default" type="button" onClick={()=>this.props.view(this.props.index)}><i className="fa fa-eye"></i></button>
                </td>
                                                                                                                       
            </tr>   
                
        );
    }
}

export default  QuotationUserDisplay;



// WEBPACK FOOTER //
// ./src/components/QuotationUserDisplay.js